<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input-facade
      class="form-control text-uppercase"
      v-model="inputValue"
      :id="inputId"
      :mask="inputMask"
      masked
      :disabled="disabled"
      :placeholder="inputPlaceholder"
      @change="emitValue('change', $event)"
      @input="emitValue('input', $event)"
      @blur="emitValue('blur', $event)"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import { PersonalIdentifications } from '@/common/enums/PersonalIdentifications'

export default {
  name: 'IdentificationCodeInput',
  mixins: [applicationInputMixin, applicationFormMixin, visitorsSectionMixin, visitorInputMixin],

  props: {
    inputLabel: {
      default: 'Код подразделения'
    },

    inputName: {
      default: 'identification_code'
    },

    inputPlaceholder: {
      default: '___-___'
    }
  },

  computed: {
    inputId () {
      return `form-visitor-identification-code-${this.visitorIndex}`
    },

    inputMask () {
      let mask = 'AAAAAAAAAAA'
      if (this.visitor.personal.identification_id === PersonalIdentifications.PASSPORT) {
        mask = '###-###'
      }

      return mask
    }
  }
}
</script>
